import InitComponent from "./init";
import { useDispatch, useSelector } from "react-redux";
import { AccountContext } from "../login/account";
import { useContext, useEffect } from "react";
import * as app from "@/app/app.slice";
import * as admin from "@/views/admin-dashboard/admin.slice";
import Login from "../login";

function Init() {
  const dispatch = useDispatch();
  const { getSession } = useContext(AccountContext);
  const statusLogin = useSelector(admin.selectStatusLogin);

  useEffect(() => {
    getSession()
      .then((session) => {
        dispatch(admin.setStatusLogin({ status: admin.StatusLogin.LOGGED_IN }));
      })
      .catch((err) => {
        dispatch(
          admin.setStatusLogin({ status: admin.StatusLogin.LOGGED_OUT })
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //

  if (statusLogin === admin.StatusLogin.LOGGED_IN) {
    dispatch(app.fetchServices());
    dispatch(app.fetchAnnouncements());

    return <InitComponent />;
  } else {
    return <Login />;
  }
}
export default Init;
